import { useCallback } from "react";
import {
  useExportTransactionsPdf,
  useExportManagementTransactionsPdf,
} from "../../../hooks/queries/useTransactionQueries";
import { toastService } from "../../../providers";

export const usePdfExport = ({
  isSuperAdmin,
  searchQuery,
  dateRange,
  serviceCodes,
  merchantId,
  page = 0,
  size = 10,
} = {}) => {
  const regularExportParams = {
    searchQuery: searchQuery || "",
    startDate: dateRange?.startDate || "",
    endDate: dateRange?.endDate || "",
    serviceCodes: serviceCodes?.length ? serviceCodes : [],
  };

  const managementExportParams = {
    searchQuery: searchQuery || "",
    startDate: dateRange?.startDate || "",
    endDate: dateRange?.endDate || "",
    serviceCodes: serviceCodes?.length ? serviceCodes : [],
    merchantId: merchantId || "",
    page,
    size,
  };

  const regularExport = useExportTransactionsPdf(regularExportParams);
  const managementExport = useExportManagementTransactionsPdf(
    managementExportParams,
  );

  const exportPdf = isSuperAdmin
    ? managementExport.mutate
    : regularExport.mutate;
  const isPending = isSuperAdmin
    ? managementExport.isPending
    : regularExport.isPending;

  const handleExport = useCallback(() => {
    toastService.info("Exporting PDF. Your download will begin shortly...");

    exportPdf(undefined, {
      onSuccess: (response) => {
        const blob = response.data;
        const url = globalThis.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `transactions_${new Date().toISOString().slice(0, 10)}.pdf`,
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        globalThis.URL.revokeObjectURL(url);
        toastService.success("Export complete! PDF download started.");
      },
      onError: (_err) => {
        toastService.error("Failed to export PDF");
      },
    });
  }, [exportPdf]);

  return {
    handleExport,
    isExporting: isPending,
  };
};

export default usePdfExport;
